export default __webpack_public_path__ + "scripts/jsstore.worker.min.8d51ff43e755004572b9a32f7b8c4595.js";